window.bz_search_module = angular.module('bzSearchModule', [
  'ui.bootstrap',
  'bzLocationModule',
  'bzProjectPreferencesModule',
])
